import { tracking } from '@iwoca/frontend-tracking-library';
import { IconExternalLink } from '@iwoca/icons';
import { Skeleton } from '@iwoca/orion';

import { Seller } from './sellerDirectory';

export const SellerCard = ({ seller }: { seller: Seller }) => {
    const sanitiseWebsite = (website: string) =>
        website
            .replace('http://', '')
            .replace('https://', '')
            .replace('www.', '')
            .replace(/\/$/, '');

    const trackSellerClick = (seller: Seller) => {
        tracking.ampli.sellerDirectorySellerClicked({
            seller_name: seller.name,
            seller_state_key: seller.state_key,
            url: seller.website
        });
    };

    return (
        <a
            href={seller.website}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackSellerClick(seller)}
            className="relative flex min-h-[100px] min-w-[200px] flex-col gap-s rounded-s border border-solid border-secondary-90 bg-structure-100 p-m text-primary-10 no-underline hover:border-primary-40 hover:shadow-black-m"
        >
            <IconExternalLink className="absolute right-m top-m fill-primary-40" />
            <span className="w-[calc(100%-20px)] text-m font-bold">
                {seller.name}
            </span>
            <span className="text-xs font-reg">
                {sanitiseWebsite(seller.website)}
            </span>
            <span className="w-max rounded-xs border border-solid border-secondary-90 px-xs py-2xs text-xs font-med text-secondary-40">
                {seller.category}
            </span>
        </a>
    );
};

export const LoadingCard = () => {
    return (
        <div className="relative flex min-h-[100px] min-w-[200px] flex-col gap-s rounded-s border border-solid border-secondary-90 bg-structure-100 p-m text-primary-10 no-underline hover:border-primary-40 hover:shadow-black-m">
            <IconExternalLink className="absolute right-m top-m fill-primary-40" />
            <span className="w-[calc(100%-20px)] text-m font-bold">
                <Skeleton />
            </span>
            <span className="text-xs font-reg">
                <Skeleton />
            </span>
            <span className="w-max rounded-xs border border-solid border-secondary-90 px-xs py-2xs text-xs font-med text-secondary-40">
                <Skeleton />
            </span>
        </div>
    );
};
